import Vue from "vue";
import Vuex from "vuex";
//import axios from "axios";
import errors from "@/services/errors";

Vue.use(Vuex);

export default {
  namespaced: true,
  state: {
    dash: null,
    results: null,
    pagination: null,
    statusId: null,
    orderBy: null,
    search: null,
    page: 0,
    pageSize: 10,
    totalResults: null,
    subscriptionDetails: null,
    listUpdated: false
  },
  mutations: {
    SET_DASH(state, payload) {
      state.dash = payload;
    },
    SET_RESULTS(state, payload) {
      state.results = payload.results;
      state.pagination = payload.pagination;
      state.page = payload.pagination.page;
      state.pageSize = payload.pagination.pageSize;
      state.totalResults = payload.pagination.totalResults;
    },
    SET_STATUS_ID(state, payload) {
      state.statusId = payload;
    },
    SET_ORDER_BY(state, payload) {
      state.orderBy = payload;
    },
    SET_SEARCH(state, payload) {
      state.search = payload;
    },
    SET_PAGE(state, payload) {
      state.page = payload;
    },
    SET_RESET_PAGE(state, payload) {
      state.page = 0;
    } /*
    SET_PAGE_SIZE(state, payload) {
      state.pageSize = payload;
      state.page = 1; //reset page on page size change
    },*/,
    SET_SUBSCRIPTION_DETAILS(state, payload) {
      state.subscriptionDetails = payload;
    },
    SET_LIST_UPDATED(state, payload) {
      state.listUpdated = payload;
    }
  },
  actions: {
    //PRE: you can send payload.params to override and set params
    //     at call time. Otherwise it uses the params previously set.
    async load({ commit }, payload) {
      try {
        //console.log("userStore: user data stored");
        const res = await Vue.prototype.$axios.get(`/subscriptions`, {
          params: {
            status: this.state.subscriptions.statusId || "",
            orderBy: this.state.subscriptions.orderBy || "",
            page: this.state.subscriptions.page + 1,
            pageSize: this.state.subscriptions.pageSize,
            search: this.state.subscriptions.search || ""
          }
        });
        if (res.status != 200) throw errors.handleHTTPError(res);
        if (res.data.results.length > 0) {
          commit("SET_RESULTS", res.data);
        }
      } catch (error) {
        throw error;
      }
    },
    async loadDash({ commit }, payload) {
      try {
        //console.log("userStore: user data stored");
        const res = await Vue.prototype.$axios.get(`/subscriptions/dash`);
        if (res.status != 200) throw errors.handleHTTPError(res);
        if (res.data) {
          commit("SET_DASH", res.data);
        }
      } catch (error) {
        throw error;
      }
    },
    async loadOne({ commit }, id) {
      try {
        //console.log("userStore: user data stored");
        const res = await Vue.prototype.$axios.get(`/subscriptions/${id}`);
        if (res.status != 200) throw errors.handleHTTPError(res);
        commit("SET_SUBSCRIPTION_DETAILS", res.data);
      } catch (error) {
        throw error;
      }
    },
    async save({ commit }, params) {
      try {
        //console.log("userStore: user data stored");
        let res = await Vue.prototype.$axios.put(
          `/subscriptions/${params.id}`,
          params
        );
        if (res.status != 200) throw errors.handleHTTPError(res);
        commit("SET_SUBSCRIPTION_DETAILS", res.data);
        return res.data.id;
      } catch (error) {
        throw error;
      }
    },
    async add({ commit }, params) {
      try {
        //console.log("userStore: user data stored");
        let res = await Vue.prototype.$axios.post("/subscriptions", {
          name: params.name,
          amount: params.amount,
          frequencyId: params.frequencyId,
          endDate: params.endDate,
          freeTrialDays: params.freeTrialDays,
          costCenterERPCode: params.costCenterERPCode,
          businessUnitId: params.businessUnitId,
          productId: params.productId
        });
        if (res.status != 201) throw errors.handleHTTPError(res);

        commit("SET_SUBSCRIPTION_DETAILS", res.data);
        return res.data.id;
      } catch (error) {
        throw error;
      }
    },
    async delete({ commit }, id) {
      try {
        //console.log("userStore: user data stored");
        let res = await Vue.prototype.$axios.delete(`/subscriptions/${id}`);
        if (res.status != 200) throw errors.handleHTTPError(res);
      } catch (error) {
        throw error;
      }
    },
    async generateLinkToken({ commit }, id) {
      try {
        //console.log("userStore: user data stored");
        let res = await Vue.prototype.$axios.get(`/subscriptions/${id}/link`);
        if (res.status != 200) throw errors.handleHTTPError(res);

        return res.data.linkToken;
      } catch (error) {
        throw error;
      }
    }
  },
  getters: {
    subscriptions: state => {
      const subscriptions = {
        dash: state.dash,
        results: state.results,
        pagination: state.pagination,
        statusId: state.statusId,
        orderBy: state.orderBy,
        search: state.search,
        page: state.page,
        pageSize: state.pageSize
      };
      return subscriptions;
    },
    listUpdated: state => {
      return state.listUpdated;
    }
  }
};
